import { lifeQuotes } from "../Data/lifeQuotes";

function Lesson() {
  return (
    <div className="LessonsPage">
      <h1>Life Lessons</h1>
      <ul>
        {lifeQuotes.map((quote, index) => (
          <li key={index}>
            <div className="quote">
              <h3>{quote.text}</h3>
              <h4> ~ {quote.by}</h4>
            </div>
            <small>{quote.desc}</small>
            <small> , Added on: {quote.date}</small>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Lesson;
